export const TM_SUCCESS = 'TM_SUCCESS'
export const TM_FAILURE = 'TM_FAILURE'

export const FETCH_TEAM_MEMBERS_CALL = 'FETCH_TEAM_MEMBERS_CALL'
export const FETCH_TEAM_MEMBERS_CALL_FULFILLED =
  'FETCH_TEAM_MEMBERS_CALL_FULFILLED'
export const FETCH_TEAM_MEMBERS_CALL_PENDING = 'FETCH_TEAM_MEMBERS_CALL_PENDING'
export const FETCH_TEAM_MEMBERS_CALL_REJECTED =
  'FETCH_TEAM_MEMBERS_CALL_REJECTED'
